import _objectDestructuringEmpty from "@babel/runtime/helpers/esm/objectDestructuringEmpty";
import { createImmutableObjectClass } from 'immutable-less';
import Scope from 'developer-experience-shared-components/scopes/models/Scope';
import { cleanObject } from 'marketplace-ui-common/utils/formatters';
import Screenshot from 'marketplace-ui-common/records/Screenshot';
import SocialScreenshots from 'marketplace-ui-common/records/SocialScreenshots';
import { baseOffering } from '../types/BaseOffering';
import { getCategorySuperCategory } from '../../common/utils/groupTags';
import { getHasAppCertificationCredential } from '../../common/utils/Certification';
import DataSync from './DataSync';
const ListingViewDefaults = {
  agencyPricingUrl: undefined,
  appIntegrations: [],
  appLanguages: [],
  appUrl: '',
  benefits: '',
  casesUrl: undefined,
  category: undefined,
  categoryFeatures: [],
  chatUrl: undefined,
  companyName: '',
  companyUrl: undefined,
  currency: 'USD',
  dataSyncHowItWorks: undefined,
  dataSyncInfo: undefined,
  dataSyncs: [],
  email: '',
  facebookUrl: undefined,
  forumUrl: undefined,
  hubSpotFeatures: [],
  iconUrl: '',
  id: 0,
  integrationFeatures: [],
  keywords: [],
  language: undefined,
  name: '',
  neededScopeGroups: [],
  offering: baseOffering,
  offeringId: 0,
  opsHub: false,
  phone: undefined,
  pricingUrl: undefined,
  pricings: [],
  privacy2Url: undefined,
  privacy3Url: undefined,
  privacyUrl: '',
  queueDepth: undefined,
  requiredRelevantScopes: [],
  reviewNotes: undefined,
  screenshots: [],
  setupUrl: '',
  socialScreenshots: new SocialScreenshots(),
  supportLanguages: [],
  supportUrl: undefined,
  tagline: '',
  termsUrl: '',
  tiers: [],
  updatedAt: undefined,
  videoUrl: undefined
};
export default class ListingView extends createImmutableObjectClass(ListingViewDefaults, {
  fromJSON: _ref => {
    let json = Object.assign({}, (_objectDestructuringEmpty(_ref), _ref));
    const {
      category,
      dataSyncs,
      hubSpotFeatures,
      requiredRelevantScopes,
      neededScopeGroups,
      screenshots,
      socialScreenshots,
      tiers
    } = json;
    return cleanObject(Object.assign({}, json, {
      category: category,
      dataSyncs: dataSyncs.map(item => new DataSync(item)),
      hubSpotFeatures: hubSpotFeatures,
      requiredRelevantScopes: requiredRelevantScopes,
      neededScopeGroups: neededScopeGroups.map(scope => new Scope(scope)),
      screenshots: screenshots.map(item => new Screenshot(item)),
      socialScreenShots: new SocialScreenshots(socialScreenshots),
      tiers: tiers
    }));
  },
  toJSON: _ref2 => {
    let rest = Object.assign({}, (_objectDestructuringEmpty(_ref2), _ref2));
    return Object.assign({}, rest);
  }
}) {
  getSuperCategory() {
    return getCategorySuperCategory(this.category);
  }
  getSourceId() {
    return this.offering.sourceId;
  }
  getAppId() {
    const sourceId = this.getSourceId();
    return sourceId ? parseInt(sourceId, 10) : null;
  }
  getIsCertified() {
    return getHasAppCertificationCredential(this.offering.credentials);
  }
  getEventProperties() {
    const applicationId = this.getAppId();
    return {
      applicationId,
      applicationName: this.name,
      category: this.getSuperCategory(),
      certification: this.getIsCertified(),
      subcategory: this.category,
      contentLanguage: this.language,
      homemade: this.offering.homemade,
      offeringId: this.offeringId
    };
  }
}